import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faClose } from "@fortawesome/free-solid-svg-icons";
import h1 from "../images/rolef_render.png";
import h2 from "../images/elgio.png";
import h3 from "../images/Viktoriabad/render4_club.png";
import h4 from "../images/Viktoriabad/office_render.jpg";
import h5 from "../images/Viktoriabad/main_render.png";
import h6 from "../images/Ryanair/ryanair_presentation/r2.jpg";
import h7 from "../images/Ryanair/ryanair_presentation/r3.jpg";
import h8 from "../images/Ryanair/ryanair_presentation/r17.jpg";
import h9 from "../images/Ryanair/bts/workplace.png";
import h10 from "../images/Rolef/rolef_slide1.jpg";
import h11 from "../images/Miscellaneous/assets/mi1.PNG";
import h12 from "../images/Miscellaneous/assets/mi3.PNG";
import h13 from "../images/Miscellaneous/assets/mi5.PNG";
import h14 from "../images/Miscellaneous/assets/mi12.PNG";
import h15 from "../images/Miscellaneous/assets/mi18.JPG";
import h16 from "../images/Elgio/Team_downscaled.png";
import h17 from "../images/Elgio/products/checkout.png";
import h18 from "../images/Elgio/products/calender_list.png";
import h19 from "../images/drivergo/driverCover.png";
import h20 from "../images/Aachen/framed_2.png";
import h21 from "../images/BloodLiner/BL2.jpg";
import h22 from "../images/BloodLiner/BL5.jpg";
import h23 from "../images/Miscellaneous/web/intro_tridi.png";
import h24 from "../images/Miscellaneous/Etsy/circle.jpg";
import h25 from "../images/Miscellaneous/Etsy/clambar.png";
import h26 from "../images/Miscellaneous/Etsy/creation.png";
import h27 from "../images/BloodLiner/BL_Components.jpg";
import h28 from "../images/BloodLiner/BL_Header.jpg";




export default function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: h1, description: "3D Rendering of potential store layout for Rolef Project", projectId: "rolef", projectTitle: "Rolef" },
    { id: h2, description: "Event discovery page for the ELGIO website", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h3, description: "Architectural Visualization - Viktoriabad Club Area", projectId: "viktoriabad", projectTitle: "Viktoriabad" },
    { id: h4, description: "Office Interior Rendering for Viktoriabad Project", projectId: "viktoriabad", projectTitle: "Viktoriabad" },
    { id: h5, description: "Main Hall 3D Render for Viktoriabad Development", projectId: "viktoriabad", projectTitle: "Viktoriabad" },
    { id: h6, description: "Slide from Ryanair Safety Card Presentation", projectId: "ryanair", projectTitle: "Ryanair" },
    { id: h7, description: "Identified problems of current Ryanair Safety Card", projectId: "ryanair", projectTitle: "Ryanair" },
    { id: h8, description: "Showcasing of newly designed Ryanair Safety Card", projectId: "ryanair", projectTitle: "Ryanair" },
    { id: h9, description: "Behind-the-Scenes Workplace Photo from Ryanair Project", projectId: "ryanair", projectTitle: "Ryanair" },
    { id: h10, description: "Rolef Consulting Advice Launch Slide", projectId: "rolef", projectTitle: "Rolef" },
    { id: h11, description: "Social Media Content (ELGIO)", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h12, description: "Social Media Content (ELGIO)", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h13, description: "Social Media Content (ELGIO)", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h14, description: "Social Media Content (ELGIO)", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h15, description: "Social Media Content (ELGIO)", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h16, description: "ELGIO Team Portrait", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h17, description: "Ticketing Checkout Process UI for ELGIO", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h18, description: "Calendar View of nearby Events for ELGIO", projectId: "elgio", projectTitle: "ELGIO" },
    { id: h19, description: "Designs of the DriverGo mobile concept", projectId: "driver-go", projectTitle: "DriverGo" },
    { id: h20, description: "Concept of new information system in Aachen", projectId: "oepnv-aachen", projectTitle: "OePNV Aachen" },
    { id: h21, description: "Introduction slide from BloodLiner presentation", projectId: "bloodliner", projectTitle: "BloodLiner" },
    { id: h22, description: "Current Diagnostic Solutions from BloodLiner presentation", projectId: "bloodliner", projectTitle: "BloodLiner" },
    { id: h23, description: "UI mockups for AI medical Platform", projectId: "Miscellaneous", projectTitle: "Miscellaneous" },
    { id: h24, description: "Poster Design concept", projectId: "Miscellaneous", projectTitle: "Miscellaneous" },
    { id: h25, description: "Poster Design concept", projectId: "Miscellaneous", projectTitle: "Miscellaneous" },
    { id: h26, description: "Poster Design concept", projectId: "Miscellaneous", projectTitle: "Miscellaneous" },
    { id: h27, description: "Components of the BloodLiner prototype", projectId: "bloodliner", projectTitle: "BloodLiner" },
    { id: h28, description: "Finished first Prototype of the BloodLiner Project", projectId: "bloodliner", projectTitle: "BloodLiner" },
  ];
  

  function shuffle(array) {
    let a = [...array];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
  
  const [shuffledImages] = useState(() => shuffle(images));

  const closeSelectedImage = () => setSelectedImage(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!selectedImage) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeSelectedImage();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImage]);
  
  return (
    <div className="main" style={{ justifyContent: "center", gap: "10px"}}>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <div className="content">
        <div className="intro-text">Hello, my Name is Niclas</div>
        {isMobile && 
          <div>
            <Link to="/curriculum-vitae">CV · </Link>
            <Link to="/about">About · </Link>
            <Link to="/projects">Projects · </Link>
            <Link to="/inspiration">Inspiration · </Link>
            <Link to="/contact">Contact</Link>
          </div>
        }
      </div>
      <div className="slider">
        <div className="slide-track">
          {shuffledImages.concat(shuffledImages).map((img, index) => (
            <div className="slide" key={index}>
              <div className="slide-container">
                <div className="slide-description">
                  <div className="flex-row gap-1 lightgrey" style={{marginLeft: "10px"}}>
                      <div>●</div>
                      <div>{img.description}</div>
                    </div>
                </div>
                <button
                  className="home-slide-button"
                  type="button"
                  onClick={() => setSelectedImage(img)}
                  aria-label={`Open ${img.description}`}
                >
                  <img
                    src={img.id}
                    alt="slide"
                    loading={index < 4 ? "eager" : "lazy"}
                    decoding="async"
                    fetchPriority={index < 4 ? "high" : "auto"}
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {selectedImage && (
        <div className="home-image-overlay" onClick={closeSelectedImage}>
          <div className="home-image-modal" onClick={(event) => event.stopPropagation()}>
            <button
              className="home-image-close"
              type="button"
              onClick={closeSelectedImage}
              aria-label="Close image preview"
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
            <img
              className="home-image-large"
              src={selectedImage.id}
              alt={selectedImage.description}
              decoding="async"
            />
            <div className="home-image-details">
              <div className="home-image-caption">{selectedImage.description}</div>
              <Link
                className="home-image-link"
                to={`/project/${selectedImage.projectId}`}
                onClick={closeSelectedImage}
              >
                <span>View Project</span>
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
